import {customAxiosBE} from "../config";

export async function getFlixSettings() {
    return customAxiosBE.get(`/settings/flix`, {
        headers: {
            "Accept-Language": "rs"
        }
    })
}

export async function getFlixOrderDetails(orderId, orderToken){
    return customAxiosBE.get(`/flix/order-details?orderId=${orderId}&orderToken=${orderToken}`)
}

export async function getFlixOrderQrCode(orderId, orderToken){
    return customAxiosBE.get(`/flix/qr-code?orderId=${orderId}&orderToken=${orderToken}`)
}
